import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e20ba1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "template-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "template-header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Resume Templates"),
  /*#__PURE__*/_createElementVNode("p", null, "Choose a template for your resume")
], -1))
const _hoisted_3 = { class: "template-grid" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "template-info" }

import { ResumeTemplates } from "../../data/Templates";
import { TemplateOptions } from "../../../../server/src/models/dtos/ResponseDtos";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateSelector',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ResumeTemplates), (template) => {
        return (_openBlock(), _createElementBlock("div", {
          key: template.template,
          class: _normalizeClass(["template-item", { active: _ctx.modelValue === template.template }]),
          onClick: ($event: any) => (_ctx.$emit('update:modelValue', template.template))
        }, [
          _createElementVNode("img", {
            src: template.previewImage,
            alt: template.name,
            class: "template-image"
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h4", null, _toDisplayString(template.name), 1),
            _createElementVNode("p", null, _toDisplayString(template.description), 1)
          ])
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})